module.exports = __webpack_public_path__ + "static/media/bronze.10d3afb7.svg";